/** ສະກຸນເງິນຫຼັກ — Lao Kip (LAK) */
export const PRIMARY_CURRENCY = "LAK" as const;

const lakFormatter = new Intl.NumberFormat("lo-LA", {
  style: "currency",
  currency: PRIMARY_CURRENCY,
  maximumFractionDigits: 0,
});

export function formatLak(
  amount: number | string | null | undefined,
): string {
  if (amount == null || amount === "") return "—";
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  return lakFormatter.format(n);
}

export function formatLakRange(
  min: number | string | null | undefined,
  max: number | string | null | undefined,
): string {
  if (min == null || min === "") return "—";
  const nMin = Number(min);
  const nMax =
    max != null && max !== "" ? Number(max) : nMin;
  if (!Number.isFinite(nMin)) return "—";
  if (nMin === nMax) return formatLak(nMin);
  return `${formatLak(nMin)} – ${formatLak(nMax)}`;
}
